<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div class="crud-title">
              <translate>UPDATE</translate>
            </div>
          </q-card-section>
          <q-card-section
            class="q-px-lg container-landfillManagementPage full-width row"
          >
            <jt-dynamic-form
              ref="dynamicForm"
              :inputs="inputs"
              :relacionamentos="elements[0].relacionamentos"
              :model="elements[0].dadosForm"
              :interface="elements[0].nmInterface"
              form-class="form dynamic"
              @composition-button-click="onCompositionButtonClick"
              @composition-modal-close="onCloseCompositionModal"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      class="row full-width q-col-gutter-lg justify-center q-py-md"
      v-if="forms[0] && forms[0].buttons.length > 0"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm"
          ><translate>CLEAN</translate></q-btn
        >
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="_actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'
import treatmentTypesContants from './treatmentTypesContants.js'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'landfillManagementPage',
  components: {},
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
export default class LandfillManagementPage extends Vue {
  selectedOrgaoAccount = undefined
  lastAction = ''

  _actionButton (button) {
    this.transformTreatmentTypeCompositionsToArray(button)
    this.actionButton(button)
  }

  transformTreatmentTypeCompositionsToArray (button) {
    if (button.action === 'landfillManagement.alterar') {
      this.elements[0].dadosForm.landfillResidues.forEach(lr => {
        if (this.isObjectAStringType(lr.treatmentTypeCode)) {
          lr.treatmentTypeCode = JSON.parse(this.formatStringToDoubleBrackets(lr.treatmentTypeCode))
        }
      })
    }
  }

  get inputs () {
    this.elements[0].inputs?.forEach(input => {
      if (input.type == 'COMPOSICAO') {
        input.isPaginated = true
      }
    })
    return this.elements[0].inputs
  }

  lastModifyAgencyAccount = {}

  onCloseCompositionModal (composition) {
    this.setTreatmentTypeGridValue(composition)
  }

  setTreatmentTypeGridValue (composition) {
    if (this.lastAction === 'btSalvarComposicao') {
      if (this.isObjectAStringType(composition.treatmentTypeCode)) {
        composition.treatmentTypeCode = JSON.parse(this.formatStringToDoubleBrackets(composition?.treatmentTypeCode))
      }
      const contentsTypeStringValues = (composition?.treatmentTypeCode || []).map(e => treatmentTypesContants[e]).join(', ')
      composition.treatmentTypeDescription = contentsTypeStringValues
      this.$nextTick(() => {
        const actualCompositionOnGrid = this.elements[0].dadosForm.landfillResidues?.filter(e => e.residue == composition.residue)
        if (actualCompositionOnGrid) {
          this.$set(this.elements[0].dadosForm.landfillResidues[actualCompositionOnGrid[0].__index], 'treatmentTypeDescription', contentsTypeStringValues)
          this.$forceUpdate()
        }
      })
    }
  }

  isObjectAStringType (object) {
    return Object.prototype.toString.call(object) === '[object String]'
  }

  formatStringToDoubleBrackets (str) {
    if (/^\[{2,}|\]{2,}$/.test(str)) {
      return `[${str.replace(/^\[{2,}|\]{2,}$/g, '')}]`
    }
    return str
  }

  async onCompositionButtonClick (param) {
    this.lastAction = param.button.name
    this.transformTreatmentTypeCodeToStringWhenOpenModal(param)
    if (param.button.name === 'btSalvarComposicao' && param.compositionId === 'landfillResponsibles') {
      const { registros } = await repository.resolveLogic('landfillResponsible.manageNewResponsable',
        { landfillResponsibles: param.model })
      this.$set(this.elements[0].dadosForm, 'landfillResponsibles', registros)
    } else if (param.compositionId === 'environmentalAgencyAccounts') {
      this.handleEnvironmentalAgencyAccount(param)
    }
    this.inactiveAllProceduresWhenAddNew(param)
    if (param.button.name === 'btSalvarComposicao' && param.compositionId === 'landfillResidues') {
      param.model[param.model.length]
    }
    this.setFieldsToReadOnly(param)
  }

  setFieldsToReadOnly (param) {
    if (param.button.name === 'icAlterarComposicao' && param.compositionId === 'landfillResidues') {
      param.formConfig.inputs.forEach(input => {
        if (input.name != 'treatmentTypeCode') {
          input.readonly = true
        }
      })
    }
    if (param.button.name === 'btExecutar') {
      this.$emit(
        'action-button',
        param.button,
        { landfill: this.forms[0].dadosForm.landfill },
        this
      )
    }
  }

  transformTreatmentTypeCodeToStringWhenOpenModal (param) {
    if (this.isObjectAStringType(param?.formConfig?.dadosForm?.treatmentTypeCode) && this.lastAction === 'btSalvarComposicao') {
      param.formConfig.dadosForm.treatmentTypeCode = JSON.parse(this.formatStringToDoubleBrackets(param.formConfig.dadosForm.treatmentTypeCode))
    }
  }

  inactiveAllProceduresWhenAddNew (params) {
    if (params.compositionId === 'landfillLaboratoryProcedures' && params?.button?.name === 'btSalvarComposicao') {
      const models = params.model
      for (let index = 0; index < (models.length - 1); index++) {
        params.model[index].available = false
        if (params.model[index].id) {
          params.model[index].flAlterado = 'S'
        } else {
          params.model[index].flAlterado = 'N'
        }
      }
      models[models.length - 1].available = true
    }
  }

  handleEnvironmentalAgencyAccount (param) {
    this.setToFalseOtherMains(param)
    this.alterFieldToPassword(param)
  }

  alterFieldToPassword (param) {
    if (param?.formConfig?.inputs) {
      const input = param.formConfig.inputs.find(i => i.name === 'password')
      if (input) {
        input.type = 'password'
        input.dataType = 'password'
      }
    }
  }

  setToFalseOtherMains (param) {
    if (param?.button?.name === 'btSalvarComposicao') {
      const selectedItem = this.getSelectedItem(param)
      if (selectedItem.main) {
        param.model.forEach(m => {
          m.main = false
          if (m.id) m.flAlterado = 'S'
          else m.flAlterado = 'N'
        })
        selectedItem.main = true
      }
    } else { this.selectedOrgaoAccount = param.params }
  }

  isEmpty (obj) {
    if (obj) { return Object.keys(obj).length === 0 }
    return true
  }

  getSelectedItem (param) {
    if (!this.isEmpty(this.selectedOrgaoAccount)) {
      return this.selectedOrgaoAccount
    }
    return param?.model[(param?.model?.length | 0) - 1]
  }
}
</script>
<style lang="stylus" scoped>
.container-landfillManagementPage{
  .dynamic-form #scroll-area{
    height: calc(70vh - 10px) !important;
  }

@media only screen and (max-height: 898px) {
  .dynamic-form {
    #scroll-area {
      height: calc(70vh - 10px) !important;
    }
  }
}

@media only screen and (max-height: 810px) {
  .dynamic-form {
    #scroll-area {
      height: calc(65vh - 10px) !important;
    }
  }
}
}
</style>
